import { GetCriteriaNameFn } from '../features/Monitor/hooks/useCriteriaNames';
import i18n from './i18n';

export type AlarmLookupType = {
  type: string;
  id: string;
  displayName?: string;
  fill?: string;
  filterEnabled?: boolean;
};

export const alarmLookup: AlarmLookupType[] = [
  {
    type: 'environment',
    id: 'environment',
    fill: 'rgba(87, 91, 207, 1)',
  },
  {
    type: 'environment',
    id: 'evil_twin',
    fill: 'rgba(87, 91, 207, .8)',
  },
  {
    type: 'environment',
    id: 'parallel_network',
    fill: 'rgba(87, 91, 207, .6)',
  },
  {
    type: 'environment',
    id: 'thermal_reboot',
    fill: 'rgba(87, 91, 207, .4)',
  },
  {
    type: 'environment',
    id: 'non_thermal_reboot',
    fill: 'rgba(87, 91, 207, .2)',
  },
  {
    type: 'internet_connection',
    id: 'internet_connection',
    fill: 'rgba(86, 124, 124, 1)',
  },
  {
    type: 'internet_connection',
    id: 'csp_outage',
    fill: 'rgba(86, 124, 124, 0.8)',
  },
  {
    type: 'internet_connection',
    id: 'cloud_outage',
    fill: 'rgba(86, 124, 124, 0.6)',
  },
  {
    type: 'internet_connection',
    id: 'offline_pod',
    fill: 'rgba(86, 124, 124, 0.4)',
  },
  {
    type: 'internet_connection',
    id: 'offline_network',
    fill: 'rgba(86, 124, 124, 0.2)',
  },
  {
    type: 'stability',
    id: 'stability',
    fill: 'rgba(0, 190, 219, 1)',
  },
  {
    type: 'stability',
    id: 'too_many_optimizations',
    fill: 'rgba(0, 190, 219, 0.8)',
  },
  {
    type: 'stability',
    id: 'failed_optimizations',
    fill: 'rgba(0, 190, 219, 0.6)',
  },
  {
    type: 'network_speed',
    id: 'network_speed',
    fill: 'rgba(201, 197, 114, 1)',
  },
  {
    type: 'network_speed',
    id: 'download_volatile',
    fill: 'rgba(201, 197, 114,  0.8)',
  },
  {
    type: 'network_speed',
    id: 'download_low',
    fill: 'rgba(201, 197, 114,  0.6)',
  },
  {
    type: 'pod_qoe',
    id: 'pod_qoe',
    fill: 'rgba(129, 187, 133, 1)',
  },
  {
    type: 'device_qoe',
    id: 'device_qoe',
    fill: 'rgba(133, 86, 112, 1)',
  },
  {
    type: 'wifi_coverage',
    id: 'wifi_coverage',
    fill: 'rgba(99, 39, 170, 1)',
  },
  {
    type: 'wifi_coverage',
    id: 'coverage',
    fill: 'rgba(99, 39, 170, 0.8)',
  },
  {
    type: 'wifi_coverage',
    id: 'pod_placement',
    fill: 'rgba(99, 39, 170, 0.6)',
  },
];

export const alarmCategoryColors: AlarmLookupType[] = [
  {
    fill: '#575BCF',
    type: 'environment',
    id: 'environment',
  },
  {
    fill: '#567C7C',
    type: 'internet_connection',
    id: 'internet_connection',
  },

  {
    fill: '#00BEDB',
    type: 'stability',
    id: 'stability',
  },
  {
    fill: '#C9C572',
    type: 'network_speed',
    id: 'network_speed',
  },
  {
    fill: '#81BB85',
    type: 'pod_qoe',
    id: 'pod_qoe',
  },
  {
    fill: '#855670',
    type: 'device_qoe',
    id: 'device_qoe',
  },
  {
    fill: '#6327AA',
    type: 'wifi_coverage',
    id: 'wifi_coverage',
  },
];

type filterItemType = {
  label: string;
  value: string;
};

export const getDurationItems = (t: typeof i18n.t): filterItemType[] => {
  return [
    { label: t('monitors.durationFilters.last24hrs'), value: '1' },
    { label: t('monitors.durationFilters.last7days'), value: '7' },
    { label: t('monitors.durationFilters.last30days'), value: '30' },
    { label: t('monitors.durationFilters.last90days'), value: '90' },
  ];
};

export const mapChartDurationToTicks = (duration: number) => {
  if (duration === 24) return 4;
  if (duration === 7) return 1;
  if (duration === 30) return 5;
  if (duration === 90) return 15;
};

export const heroStatsMock = {
  latest_typical_stats: [
    {
      average_health_score: 87.85188220238688,
    },
  ],
  latest_partner_stats: [
    {
      average_health_score: 87.91610670358341,
      location_count: 93905,
      any_severity_location_count: 44756,
      maximum_severity_location_count: 44649,
    },
  ],
  recent_partner_stats: [
    {
      average_health_score: 86,
      maximum_severity_location_count: 71853,
    },
  ],
};

export const alarmToColor = (alarmId: string): string => {
  const found = alarmLookup.find((alarm) => alarm.id === alarmId);
  return found?.fill ? found.fill : '#303030 ';
};

export const alarmToDisplayname = (
  alarmId: string,
  getCriteriaName: GetCriteriaNameFn,
): string => {
  if (alarmId === 'location_count')
    return i18n.t('monitors.criteriaNames.location');

  const found = alarmLookup.find((alarm) => alarm.id === alarmId);
  return getCriteriaName(found?.id);
};

export const alarmToType = (alarmType: string): string => {
  if (alarmType === 'location_count') {
    return 'location';
  }

  const found = alarmLookup.find((alarm) => alarm.id === alarmType);
  if (found) {
    return found.type || `unknown-${alarmType}`;
  }
  return `unknown-${alarmType}`;
};
